import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any): { total: number } | null => {
  //   console.log(res.data);

  if (Object.keys(res.data).length) {
    return res.data.data;
  }

  return null;
};

export const useGetTotalPatients = ({
  dateRange,
  startDate,
  endDate,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.totalPatientsWithFilters({
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: () => {
      return api.get("analytics/patients/counts", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Total patients]", res);
      handleErrors(res, "query");
    },
  });
};
